import { render } from "./Munkahely.vue?vue&type=template&id=0ae12894&scoped=true"
import script from "./Munkahely.vue?vue&type=script&lang=js"
export * from "./Munkahely.vue?vue&type=script&lang=js"

import "./Munkahely.vue?vue&type=style&index=0&id=0ae12894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae12894"]])

export default __exports__